import { Component, OnInit, Injector, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { EarningServiceProxy, ProgramLastRunTimesOutput } from '@shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';
import { FeatureFlagService } from "shared/feature-flagging/feature-flag.service";

@Component({
    templateUrl: './program-last-runtimes.component.html',
    selector: 'program-last-runtimes',
    styleUrls: ['./program-last-runtimes.component.less']
})
export class ProgramLastRuntimesComponent extends AppComponentBase implements OnInit {

    isLoading: boolean;
    loadingError: boolean = false;
    programLastRunTimes: ProgramLastRunTimesOutput;

    constructor(
        injector: Injector,
        private _earningsService: EarningServiceProxy,
        private _featureFlagService: FeatureFlagService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.getProgramLastRunDates();
    }

    getProgramLastRunDates() {
        if (this.isVylorTenant()) {
            return;
        }

        this.isLoading = true;
        this.loadingError = false;

        this._earningsService.getProgramAndLRPLastRunTimes()
            .pipe(finalize(() => {
                this.isLoading = false;
            }))
            .subscribe(
                result => {
                    this.programLastRunTimes = result;
                },
                error => {
                    this.loadingError = true;
            });
    }

    isVylorTenant(): boolean {
        return (this.appSession.tenancyName || '').toLowerCase() === 'vylor';
    }
}
